var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPostItMutaties(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e{fill:url(#b);}.f{fill:#e3c5d6;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 42.05,
    y1: 613.68,
    x2: 42.05,
    y2: 614.77,
    gradientTransform: "translate(-3808.67 55920.54) scale(91.75 -90.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebd0df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4d7e7"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "c",
    className: "e",
    d: "M100,98.27L0,99.14,.29,0H98.27l1.73,98.27Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "d",
    className: "f",
    d: "M98.6,18.8H.23L.29,0H98.27l.33,18.8Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostItMutaties);
export default __webpack_public_path__ + "static/media/Post-it-mutaties.ae73273628ed1071ff72e3cc38149e30.svg";
export { ForwardRef as ReactComponent };